import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import InputColor from "../../../views/dashboard/settings/branding/InputColor";
import submit from "submit-form";
import { getRandomColor } from "../../../utils/annual-planner-helpers";
import Modal from "../../modal-new";

export const EditTemplateModal = (
  { templateId, organizationCoachId },
  { locals }
) => {
  const {
    phasesTemplates: { templates },
  } = locals;

  const currentTemplate = templates.find(
    (template) => template._id === templateId
  );

  let randomColor = useRef(getRandomColor());

  const [formState, setFormState] = useState({
    phase_template_name: currentTemplate.templateName,
    phases: currentTemplate.phases,
  });

  const [emptyPhasesState, setEmptyPhasesState] = useState(false);

  const { phase_template_name, phases } = formState;

  const handleSubmit = (e) => {
    e.preventDefault();
    const emptyPhases = phases.find((phase) => phase.phaseName === "");
    if (!phase_template_name || emptyPhases) return;

    let body = {
      templateId,
      phase_template_name,
      phases,
    };

    if (organizationCoachId) {
      body = { ...body, organizationCoachId };
    }

    submit("/actions/annual-planner/update-phase-template", {
      method: "POST",
      body,
    });
  };

  useEffect(() => {
    const emptyPhases =
      !!phases.find((phase) => phase.phaseName === "") || false;
    const emptyTemplateName = !phase_template_name.length;
    setEmptyPhasesState(emptyPhases || emptyTemplateName);
  }, [phases, phase_template_name]);

  const handleChange = (input, payload, index = false) => {
    if (index !== false) {
      const newPhases = Array.from(phases);
      newPhases[index][input] = String(payload);
      setFormState(Object.assign({}, formState, { phases: newPhases }));
    } else setFormState(Object.assign({}, formState, { [input]: payload }));
  };

  const handleAddPhase = () => {
    const newPhases = Array.from(phases);
    newPhases.push({ phaseName: "", phaseColor: getRandomColor() });
    setFormState(Object.assign({}, formState, { phases: newPhases }));
  };

  const handleRemovePhase = (index) => {
    const newPhases = Array.from(phases);
    newPhases.splice(index, 1);
    setFormState(Object.assign({}, formState, { phases: newPhases }));
  };

  return (
    <Modal
      className="annual-planner-modal add-phase-template-modal"
      title={"Edit Phase Template"}
    >
      <div className="body">
        <form
          id="edit-phase-template-form"
          className="annual-planner-modal-form add-phase-template-modal-form"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          <div role="wrapper" className="template-name">
            <label className="label">Phase Group Name</label>
            <input
              type={"text"}
              name="phase_template_name"
              className="phase-template-name text-input"
              placeholder="Enter group name"
              defaultValue={phase_template_name}
              onChange={({ target: { value } }) =>
                handleChange("phase_template_name", value)
              }
            />
          </div>
          <div className="phases-labels" role="wrapper">
            <label>Phase Name</label>
            <label>Color</label>
          </div>
          {phases.map((phase, index) => (
            <div
              className="phase"
              role="wrapper"
              key={`add-temp-phase-${index}`}
            >
              <input
                type={"text"}
                id={`phaseName${index}`}
                name={"phaseName"}
                className="phase-name text-input"
                placeholder="Enter phase name"
                defaultValue={phase.phaseName}
                onChange={({ target: { value } }) =>
                  handleChange("phaseName", value, index)
                }
              />
              <InputColor
                onChange={({ target: { value } }) =>
                  handleChange("phaseColor", value, index)
                }
                value={phase.phaseColor}
                customClassNames={"phase-color"}
              />
              <img
                src="/img/new-icons/red-trash.svg"
                onClick={() => handleRemovePhase(index)}
                role="remove"
              />
            </div>
          ))}
          <div className="add-phase-row-wrapper">
            <button
              type="button"
              className="btn-add-phase"
              onClick={handleAddPhase}
            >
              <span>Add New</span>
            </button>
          </div>
        </form>
      </div>
      <footer className="phase-template-footer">
        <button
          type="button"
          role="button"
          data-action="cancel"
          onClick={() =>
            submit("/actions/refresh?", {
              method: "GET",
              body: {
                "modal[type]": "",
              },
            })
          }
        >
          Cancel
        </button>
        <button
          type="button"
          form="add-phase-template-form"
          role="button"
          data-button-type="primary"
          disabled={emptyPhasesState}
          onClick={handleSubmit}
        >
          Save
        </button>
      </footer>
    </Modal>
  );
};

EditTemplateModal.contextTypes = { locals: PropTypes.object };
